import React from 'react';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import SEO from '../../../components/SEO';
import './privatlivspolitik.css';

const PrivatlivsPolitik = () => {
  return (
    <div className="privatlivs-page">
      <SEO 
        title="Privatlivspolitik | Parla Branding"
        description="Læs hvordan Parla Branding beskytter dine personoplysninger i overensstemmelse med GDPR. Transparent information om dataindsamling og -behandling."
        url="https://www.parlabranding.dk/privatlivspolitik"
        canonicalUrl="https://www.parlabranding.dk/privatlivspolitik"
      />
      
      <Header />
      
      <main className="privatlivs-main">
        <div className="container">
          <div className="privatlivs-header">
            <h1>Privatlivspolitik</h1>
            <p className="privatlivs-updated">Sidst opdateret: 24. juli 2025</p>
          </div>

          <div className="privatlivs-content">
            <section className="privatlivs-section">
              <h2>Introduktion</h2>
              <p>
                Parla Branding respekterer dit privatliv og er forpligtet til at beskytte dine personoplysninger. 
                Denne privatlivspolitik forklarer, hvordan vi indsamler, bruger og beskytter dine data, når du 
                besøger vores hjemmeside eller bruger vores tjenester.
              </p>
            </section>

            <section className="privatlivs-section">
              <h2>Hvem er vi?</h2>
              <p>
                Parla Branding er en dansk virksomhed, der specialiserer sig i webdesign, SEO-optimering og 
                digitale markedsføringsløsninger. Vi er dataansvarlige for behandlingen af dine personoplysninger.
              </p>
              <div className="company-info">
                <p><strong>Virksomhed:</strong> Parla Branding</p>
                <p><strong>Adresse:</strong> København, Danmark</p>
                <p><strong>E-mail:</strong> kontakt@parlabranding.dk</p>
                <p><strong>Telefon:</strong> +45 36 17 00 00</p>
              </div>
            </section>

            <section className="privatlivs-section">
              <h2>Hvilke oplysninger indsamler vi?</h2>
              <p>Vi indsamler følgende typer af personoplysninger:</p>
              
              <div className="data-category">
                <h3>Kontaktoplysninger</h3>
                <ul>
                  <li>Navn</li>
                  <li>E-mailadresse</li>
                  <li>Telefonnummer</li>
                  <li>Virksomhedsnavn (hvis relevant)</li>
                </ul>
              </div>

              <div className="data-category">
                <h3>Tekniske oplysninger</h3>
                <ul>
                  <li>IP-adresse</li>
                  <li>Browsertype og -version</li>
                  <li>Operativsystem</li>
                  <li>Besøgsstatistikker og brugeradfærd</li>
                </ul>
              </div>

              <div className="data-category">
                <h3>Kommunikationsoplysninger</h3>
                <ul>
                  <li>Beskeder sendt gennem kontaktformularer</li>
                  <li>E-mailkorrespondance</li>
                  <li>Telefonsamtaler (når relevant)</li>
                </ul>
              </div>
            </section>

            <section className="privatlivs-section">
              <h2>Hvordan indsamler vi oplysninger?</h2>
              <p>Vi indsamler oplysninger på følgende måder:</p>
              <ul>
                <li><strong>Direkte fra dig:</strong> Når du udfylder kontaktformularer eller sender os e-mails</li>
                <li><strong>Automatisk:</strong> Gennem cookies og analyseværktøjer når du besøger vores hjemmeside</li>
                <li><strong>Tredjeparter:</strong> Fra legitime kilder som Google Analytics (anonymiseret data)</li>
              </ul>
            </section>

            <section className="privatlivs-section">
              <h2>Hvorfor behandler vi dine oplysninger?</h2>
              <p>Vi behandler dine personoplysninger til følgende formål:</p>
              
              <div className="purpose-category">
                <h3>Kundeservice og kommunikation</h3>
                <p><strong>Retsgrundlag:</strong> Berettiget interesse og samtykke</p>
                <ul>
                  <li>Besvare henvendelser og spørgsmål</li>
                  <li>Levere tilbud og konsultation</li>
                  <li>Yde kundesupport</li>
                </ul>
              </div>

              <div className="purpose-category">
                <h3>Forretningsudvikling</h3>
                <p><strong>Retsgrundlag:</strong> Berettiget interesse</p>
                <ul>
                  <li>Forbedre vores tjenester</li>
                  <li>Analysere hjemmesidens performance</li>
                  <li>Markedsføring og salg</li>
                </ul>
              </div>

              <div className="purpose-category">
                <h3>Juridiske forpligtelser</h3>
                <p><strong>Retsgrundlag:</strong> Juridisk forpligtelse</p>
                <ul>
                  <li>Bogføring og regnskab</li>
                  <li>Overholdelse af skattelovgivning</li>
                  <li>Opbevaring af kontrakter</li>
                </ul>
              </div>
            </section>

            <section className="privatlivs-section">
              <h2>Hvem deler vi oplysninger med?</h2>
              <p>Vi deler dine oplysninger med følgende kategorier af modtagere:</p>
              <ul>
                <li><strong>Leverandører:</strong> Tekniske leverandører som hosting-udbydere og analyseværktøjer</li>
                <li><strong>Juridiske rådgivere:</strong> Advokater og revisorer når påkrævet</li>
                <li><strong>Myndigheder:</strong> Kun når vi er juridisk forpligtet hertil</li>
              </ul>
              <p>Vi sælger aldrig dine personoplysninger til tredjeparter.</p>
            </section>

            <section className="privatlivs-section">
              <h2>Overførsel til tredjelande</h2>
              <p>
                Nogle af vores leverandører kan være placeret uden for EU/EØS. I sådanne tilfælde sikrer vi, 
                at der er passende beskyttelsesforanstaltninger på plads, såsom EU's standardkontrakter eller 
                tilstrækkelighedsbeslutninger.
              </p>
            </section>

            <section className="privatlivs-section">
              <h2>Hvor længe opbevarer vi dine oplysninger?</h2>
              <div className="retention-category">
                <h3>Kontaktoplysninger</h3>
                <p>3 år efter sidste kontakt, medmindre du anmoder om sletning</p>
              </div>
              <div className="retention-category">
                <h3>Regnskabsoplysninger</h3>
                <p>5 år i henhold til bogføringsloven</p>
              </div>
              <div className="retention-category">
                <h3>Analysedata</h3>
                <p>26 måneder (Google Analytics standard)</p>
              </div>
            </section>

            <section className="privatlivs-section">
              <h2>Dine rettigheder</h2>
              <p>Under GDPR har du følgende rettigheder:</p>
              
              <div className="rights-list">
                <div className="right-item">
                  <h4>Ret til indsigt</h4>
                  <p>Du kan anmode om en kopi af de personoplysninger, vi har om dig</p>
                </div>
                
                <div className="right-item">
                  <h4>Ret til berigtigelse</h4>
                  <p>Du kan anmode om at få rettet unøjagtige eller ufuldstændige oplysninger</p>
                </div>
                
                <div className="right-item">
                  <h4>Ret til sletning</h4>
                  <p>Du kan anmode om at få slettet dine personoplysninger under visse omstændigheder</p>
                </div>
                
                <div className="right-item">
                  <h4>Ret til begrænsning</h4>
                  <p>Du kan anmode om begrænsning af behandlingen af dine oplysninger</p>
                </div>
                
                <div className="right-item">
                  <h4>Ret til dataportabilitet</h4>
                  <p>Du kan anmode om at få dine data i et struktureret, almindeligt anvendt format</p>
                </div>
                
                <div className="right-item">
                  <h4>Ret til indsigelse</h4>
                  <p>Du kan gøre indsigelse mod behandling baseret på berettiget interesse</p>
                </div>
              </div>
            </section>

            <section className="privatlivs-section">
              <h2>Sådan kontakter du os</h2>
              <p>
                Hvis du har spørgsmål om denne privatlivspolitik eller ønsker at udøve dine rettigheder, 
                kan du kontakte os:
              </p>
              <div className="contact-info">
                <p><strong>E-mail:</strong> kontakt@parlabranding.dk</p>
                <p><strong>Telefon:</strong> +45 36 17 00 00</p>
                <p><strong>Post:</strong> Parla Branding, København, Danmark</p>
              </div>
            </section>

            <section className="privatlivs-section">
              <h2>Klager til Datatilsynet</h2>
              <p>
                Hvis du mener, at vi ikke overholder reglerne for behandling af personoplysninger, 
                har du ret til at indgive en klage til Datatilsynet:
              </p>
              <div className="authority-info">
                <p><strong>Datatilsynet</strong></p>
                <p>Borgergade 28, 5.</p>
                <p>1300 København K</p>
                <p>Telefon: 33 19 32 00</p>
                <p>E-mail: dt@datatilsynet.dk</p>
                <p>Website: <a href="https://www.datatilsynet.dk" target="_blank" rel="noopener noreferrer">www.datatilsynet.dk</a></p>
              </div>
            </section>

            <section className="privatlivs-section">
              <h2>Ændringer til denne politik</h2>
              <p>
                Vi kan opdatere denne privatlivspolitik fra tid til anden for at afspejle ændringer i vores 
                praksis eller juridiske krav. Væsentlige ændringer vil blive meddelt på vores hjemmeside. 
                Datoen for den seneste opdatering er angivet øverst på denne side.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivatlivsPolitik;
